import { useEffect, useMemo, useState } from "react";
import { CustomerDetails } from "./CustomerDetails";
import { AdminDetails } from "./AdminDetails";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerById } from "../../Redux/Slice/Customers/GetCUstomerByIdSlice";
import { PlanDetails } from "./PlanDetails";
import { UpdateCustomer } from "../../Redux/Slice/Customers/UpdateCustomerSlice";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";
import { ConfirmModel } from "../../Model/ConfirmModel";
import { Loader } from "../../Common/Loader";
import { setUnsavedChanges } from "../../Redux/Slice/Common/SelectedTabSlice";
import CustomerApiKeyPassword from "../Profile/CustomerApiKeyPassword";
import { revokeCustomerMFA } from "../../Redux/Slice/Customers/RevokeCustomerMFASlice";
import { resendInvitation } from "../../Redux/Slice/Authentication/ResendInvitationSlice";
import { formattedFeatureData } from "../../Common/utils";

export const EditCustomer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isNavigateToPlan = location?.state?.isNavigateToPlan;
  const isEditAdmin = location?.state?.isEditAdmin;
  const [selectedTab, setSelectedTab] = useState(
    isEditAdmin ? 2 : isNavigateToPlan ? 3 : 1
  );
  const [customerId, setCustomerId] = useState(1);
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [confirmModel, setConfirmModel] = useState(false);
  const [updateBody, setUpdateBody] = useState({});
  const [customerDetails, setCustomerDetails] = useState({
    autoTopUpDate: "",
    companyName: "",
    credits: 0,
    email: "",
    expiryDate: "",
    joiningDate: "",
    planName: "",
    planType: "",
    admin: {
      firstName: "",
      lastName: "",
      email: "",
      countryCallingCode: "+61",
      phoneNumber: "",
      role: "company",
    },
  });
  const [customerFormData, setCustomerFormData] = useState({
    companyName: "",
    email: "",
    address: {
      address: "",
      state: "",
      city: "",
      country: "",
      zipCode: "",
    },
    countryCallingCode: "+61",
    phoneNumber: "",
    isDefaultEmail: false,
  });
  const [adminDetails, setAdminDetails] = useState({
    firstName: "",
    lastName: "",
    email: "",
    countryCallingCode: "+61",
    phoneNumber: "",
    role: "",
  });
  const [adminFormError, setAdminFormError] = useState({
    emailError: "",
    phoneError: "",
    firstNameError: "",
    lastNameError: "",
  });
  const [planDetails, setPlanDetails] = useState({
    subscriptionType: "",
    planId: "",
  });
  const custDetails = useSelector(
    (state) => state.customerDetailsbyId.customerDetails
  );
  const currentPlanFeatures = formattedFeatureData(
    custDetails?.data?.plan?.planTypeDetails?.features
  );

  useEffect(() => {
    let custId = location.pathname.split("/")[2];
    if (custId) {
      setCustomerId(custId);
      getCustomerDetails(custId);
    }
    if (location?.state?.selectedTab) {
      setSelectedTab(location?.state?.selectedTab);
    }
  }, []);

  const getCustomerDetails = async (custId) => {
    setIsLoading(true);
    const result = await dispatch(getCustomerById(custId));
    if (
      getCustomerById.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setCustomerDetails(result.payload.data);
    }
    setIsLoading(false);
  };

  const revokeMFA = async () => {
    setIsLoading(true);
    try {
      const result = await dispatch(
        revokeCustomerMFA(customerDetails?.admin?.id)
      );
      if (
        revokeCustomerMFA.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        setIsLoading(false);
        dispatch(setUnsavedChanges(false));
        setSuccessMessage("Customer MFA Revoked Successfully!");
        setSuccessModel(true);
        setTimeout(() => {
          setSuccessModel(false);
        }, 1500);
      } else {
        setIsLoading(false);
        setErrorMessage(result?.payload?.error?.message);
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    } catch (error) {
      setIsLoading(false);
      setErrorMessage("Something went wrong, Please try again later.");
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendInvitation = async () => {
    setIsLoading(true);
    try {
      const result = await dispatch(
        resendInvitation({ email: customerDetails?.admin?.email })
      );
      if (
        resendInvitation.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        setIsLoading(false);
        dispatch(setUnsavedChanges(false));
        setSuccessMessage("Customer Admin Invite Resend Successfully!");
        setSuccessModel(true);
        setTimeout(() => {
          setSuccessModel(false);
        }, 1500);
      } else {
        setIsLoading(false);
        setErrorMessage(result?.payload?.error?.message);
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    } catch (error) {
      setIsLoading(false);
      setErrorMessage("Something went wrong, Please try again later.");
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (custDetails) {
      setCustomerDetails(custDetails.data);
    }
  }, [custDetails]);

  const handleSubmitCustomer = async (data) => {
    // UpdateCustomerFunc(data);
    const body = {
      ...data,
      phoneNumber: data.phoneNumber ? data.phoneNumber.replace(/\D/g, "") : "",
    };
    setUpdateBody(body);
    setConfirmModel(true);
  };

  const handleSubmitPlan = async (data) => {
    const body = { id: customerId, planId: data.planId };
    // UpdateCustomerFunc(body);
    setUpdateBody(body);
    setConfirmModel(true);
  };

  const handleSubmitAdmin = async (data) => {
    const body = {
      id: customerId,
      admin: {
        ...data,
        phoneNumber: data.phoneNumber
          ? data.phoneNumber.replace(/\D/g, "")
          : "",
      },
    };
    // UpdateCustomerFunc(body);
    setUpdateBody(body);
    setConfirmModel(true);
  };

  const UpdateCustomerFunc = async () => {
    setConfirmModel(false);
    setIsLoading(true);
    const result = await dispatch(UpdateCustomer(updateBody));
    if (
      UpdateCustomer.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      dispatch(setUnsavedChanges(false));
      setSuccessMessage("Customer Updated Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        navigate(-1);
      }, 1500);
    } else {
      //TODO: error popup here
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };
  const handelCancel = () => {
    setConfirmModel(false);
  };

  const isDisabledSubmitBtn = useMemo(() => {
    return (
      adminDetails.firstName.trim() === "" ||
      adminDetails.lastName.trim() === "" ||
      adminDetails.email === "" ||
      adminFormError.emailError != "" ||
      adminFormError.phoneError != "" ||
      adminDetails.phoneNumber === ""
    );
  }, [adminDetails, adminFormError]);

  return (
    <div className="page__body">
      {isLoading ? <Loader /> : ""}
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
      {successModel ? <SuccessModel message={successMessage} /> : ""}
      {confirmModel ? (
        <ConfirmModel
          onAccept={UpdateCustomerFunc}
          onReject={handelCancel}
          yes={"Update"}
          no={"Cancel"}
          title="Update Changes!"
          message="Are you sure you want to update the changes?"
        />
      ) : (
        ""
      )}
      <div className="tabsWrap">
        <ul className="tabs">
          <li
            className={
              selectedTab === 1
                ? "tabs__link tabs__link--selected"
                : "tabs__link"
            }
            onClick={() => {
              setSelectedTab(1);
            }}
          >
            Company Details
          </li>
          <li
            className={
              selectedTab === 2
                ? "tabs__link tabs__link--selected"
                : "tabs__link"
            }
            onClick={() => {
              setSelectedTab(2);
            }}
          >
            Admin Details
          </li>
          <li
            className={
              selectedTab === 3
                ? "tabs__link tabs__link--selected"
                : "tabs__link"
            }
            onClick={() => {
              setSelectedTab(3);
            }}
          >
            Plans
          </li>
          {currentPlanFeatures?.API_DOCUMENTATION ? (
            <li
              className={
                selectedTab === 4
                  ? "tabs__link tabs__link--selected"
                  : "tabs__link"
              }
              onClick={() => {
                setSelectedTab(4);
              }}
            >
              API Key & Password
            </li>
          ) : null}
        </ul>
      </div>
      <div className="tabsContent">
        <CustomerDetails
          key={`${customerDetails?.id ?? ""}-CustomerDetails`}
          selectedTab={selectedTab}
          isEdit={true}
          customerFormData={customerFormData}
          setCustomerFormData={setCustomerFormData}
          customerDetails={customerDetails}
          setCustomerDetails={setCustomerDetails}
          handleSubmit={handleSubmitCustomer}
          planType={customerDetails?.plan?.planType}
        />
        <AdminDetails
          key={`${customerDetails?.id ?? ""}-AdminDetails`}
          selectedTab={selectedTab}
          isEdit={true}
          customerDetails={customerDetails}
          setAdminDetails={setAdminDetails}
          adminDetails={adminDetails}
          adminFormError={adminFormError}
          setAdminFormError={setAdminFormError}
          handleSubmit={handleSubmitAdmin}
          revokeMFA={revokeMFA}
          resendInvitation={handleResendInvitation}
        />
        <PlanDetails
          key={`${customerDetails?.id ?? ""}-PlanDetails`}
          selectedTab={selectedTab}
          isEdit={true}
          isDisabledBtn={isDisabledSubmitBtn}
          setAdminDetails={setPlanDetails}
          planDetails={customerDetails}
          handleSubmit={handleSubmitPlan}
        />
        <CustomerApiKeyPassword
          key={`${customerDetails?.id ?? ""}-ApiKey`}
          visible={selectedTab === 4}
          customerId={customerId}
          apiKeyAndPassword={customerDetails?.apiKeyPassword}
          customerEmail={customerDetails ? customerDetails?.admin?.email : ""}
        />
      </div>
    </div>
  );
};
